import { IApplicationState } from '../../types/redux';

export const selectCountrysideAdfoxPuids = (state: IApplicationState) => state.countrysideAdfox.puids;
